import { createTheme } from '@fluentui/react';

export const theme = createTheme({
  palette: {
    themePrimary: "#2b2071",
    themeLighterAlt: "#f3f2f9",
    themeLighter: "#d1cde8",
    themeLight: "#aca6d4",
    themeTertiary: "#6a60a9",
    themeSecondary: "#3a2f81",
    themeDarkAlt: "#261c65",
    themeDark: "#201855",
    themeDarker: "#18123f",
    neutralLighterAlt: "#faf9f8",
    neutralLighter: "#f3f2f1",
    neutralLight: "#edebe9",
    neutralQuaternaryAlt: "#e1dfdd",
    neutralQuaternary: "#d0d0d0",
    neutralTertiaryAlt: "#c8c6c4",
    neutralTertiary: "#a19f9d",
    neutralSecondary: "#605e5c",
    neutralPrimaryAlt: "#3b3a39",
    neutralPrimary: "#323130",
    neutralDark: "#201f1e",
    black: "#000000",
    white: "#ffffff",
  },
  fonts: {},
});
